import { useContext } from "react";

import { NotificationsContext } from "../../contexts/NotificationsContext";

export const useNotifications = () => {
  return useContext(NotificationsContext);
};